/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { ArrowLeft3 } from "../../icons/ArrowLeft3";
import { Size18PxColourWhiteDarkThemeFalse } from "../../icons/Size18PxColourWhiteDarkThemeFalse";
import { MasterShapesLink } from "../MasterShapesLink";
import "./style.css";

export const MasterButtonNav = ({
  className,
  divClassName,
  text = "Label",
  visible = true,
  hasIconButton = true,
  iconButtonClassName,
}) => {
  return (
    <div className={`master-button-nav ${className}`}>
      <ArrowLeft3 className="arrow-left" />
      <div className="label">
        <div className={`label-2 ${divClassName}`}>{text}</div>

        {visible && <MasterShapesLink className="line" />}
      </div>

      {hasIconButton && (
        <div className={`icon-button ${iconButtonClassName}`}>
          <Size18PxColourWhiteDarkThemeFalse className="arrow-right" />
        </div>
      )}
    </div>
  );
};

MasterButtonNav.propTypes = {
  text: PropTypes.string,
  visible: PropTypes.bool,
  hasIconButton: PropTypes.bool,
};
